import { getStockPointsList } from 'constants/queryCacheKeys';
import { getStockPoints } from 'domain/stocks';
import { useQuery } from 'react-query';
import { StocksPointsParams } from 'domain/stocks';

export const useStockPoints = (params: StocksPointsParams) => {
  return useQuery(getStockPointsList(params), () => getStockPoints(params));
};
